module.exports = __webpack_public_path__ + "static/media/food.a95ac2f4.svg";